export default __webpack_public_path__ + "static/media/cretae-course-enabled.c60879ea.svg";